import { CfFaqWidget, CfUspCard, CfMarketingBlock } from '../../models';
import { cfReferenceList } from '../../utils/mappers/cfReferenceList';

export function mapCfEntity(cfEntity = {}) {
    const result = {};

    const { fields } = cfEntity;
    const { faqList, uspCards, benefitList, tooltipText } = fields || {};

    Object.assign(result, {
        tooltipText,
        faqList: cfReferenceList(faqList).map((entity) => new CfFaqWidget(entity)),
        uspCards: cfReferenceList(uspCards).map(
            (entity) => new CfUspCard(CfUspCard.mapCfEntity(entity)),
        ),
        benefitList: cfReferenceList(benefitList).map(
            (entity) => new CfMarketingBlock(CfMarketingBlock.mapCfEntity(entity)),
        ),
    });

    return result;
}
